




import Component, { mixins } from 'vue-class-component';
import { Prop } from 'vue-property-decorator';

import formatter from '@/mixins/formatter';

@Component
export default class LargeLineCount extends mixins(formatter) {
  @Prop() private count!: number;
  @Prop({ default: '' }) id?: string;
}
